import * as React from "react";
const SvgMailSend = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H3L14 6V8L3 14H0L1 8H6V6H1L0 0Z", fill: "currentColor" }));
export default SvgMailSend;
